import {
  GET_FLEET_TRIP,
  GET_FLEET_TRIP_FAILURE,
  GET_FLEET_TRIP_SUCCESS,
  GET_DEVICE_USER_MAPPING,
  GET_DEVICE_USER_MAPPING_FAILURE,
  GET_DEVICE_USER_MAPPING_SUCCESS,
  GET_DEVICE_USERS,
  GET_DEVICE_USERS_SUCCESS,
  GET_DEVICE_USERS_FAILURE,
  STORE_STOMP_CLIENT,
} from "./actionTypes";

export const storeStompClient = (payload: { stompClient: any }) => ({
  type: STORE_STOMP_CLIENT,
  payload,
});

export const getFleetTrip = (payload: {
  clientId: string;
  ecode: string;
  tripStartDateTime: string,
  tripEndDateTime: string,
}) => ({
  type: GET_FLEET_TRIP,
  payload,
});

export const getFleetTripSuccess = (payload: any) => ({
  type: GET_FLEET_TRIP_SUCCESS,
  payload,
});

export const getFleetTripFailure = (payload: any) => ({
  type: GET_FLEET_TRIP_FAILURE,
  payload,
});

export const getDeviceUserMapping = (payload: {
  size: number;
  page: number;
}) => ({
  type: GET_DEVICE_USER_MAPPING,
  payload,
});

export const getDeviceUserMappingSuccess = (payload: any) => ({
  type: GET_DEVICE_USER_MAPPING_SUCCESS,
  payload,
});

export const getDeviceUserMappingFailure = (payload: any) => ({
  type: GET_DEVICE_USER_MAPPING_FAILURE,
  payload,
});

export const getDeviceUsers = (payload: { size: number; page: number }) => ({
  type: GET_DEVICE_USERS,
  payload,
});

export const getDeviceUsersSuccess = (payload: any) => ({
  type: GET_DEVICE_USERS_SUCCESS,
  payload,
});

export const getDeviceUsersFailure = (payload: any) => ({
  type: GET_DEVICE_USERS_FAILURE,
  payload,
});
